// File: client/src/components/rules/nodeConfigs/WebhookConfig.js
import React from 'react';
import { Form, Radio, Input, Button, Space, Divider } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import MonacoEditor from 'react-monaco-editor';

// Editor options
const editorOptions = {
    minimap: { enabled: false },
    scrollBeyondLastLine: false,
    automaticLayout: true,
    fontSize: 14,
    lineNumbers: 'on',
    wordWrap: 'on',
};

const WebhookConfig = () => {
    return (
        <div>
            <Form.Item
                name="url"
                label="URL"
                rules={[{ required: true, message: 'Please enter a URL' }]}
            >
                <Input placeholder="https://example.com/webhook" />
            </Form.Item>

            <Form.Item
                name="method"
                label="HTTP Method"
                rules={[{ required: true, message: 'Please select a method' }]}
            >
                <Radio.Group>
                    <Radio.Button value="GET">GET</Radio.Button>
                    <Radio.Button value="POST">POST</Radio.Button>
                    <Radio.Button value="PUT">PUT</Radio.Button>
                    <Radio.Button value="DELETE">DELETE</Radio.Button>
                </Radio.Group>
            </Form.Item>

            <Form.List name="headers">
                {(fields, { add, remove }) => (
                    <>
                        <Divider orientation="left">Headers</Divider>
                        {fields.map(({ key, name, ...restField }) => (
                            <Space key={key} align="baseline" style={{ display: 'flex', marginBottom: 8 }}>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'key']}
                                    rules={[{ required: true, message: 'Key required' }]}
                                >
                                    <Input placeholder="Header key" />
                                </Form.Item>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'value']}
                                    rules={[{ required: true, message: 'Value required' }]}
                                >
                                    <Input placeholder="Header value" />
                                </Form.Item>
                                <MinusCircleOutlined onClick={() => remove(name)} />
                            </Space>
                        ))}
                        <Form.Item>
                            <Button
                                type="dashed"
                                onClick={() => add()}
                                block
                                icon={<PlusOutlined />}
                            >
                                Add Header
                            </Button>
                        </Form.Item>
                    </>
                )}
            </Form.List>

            <Form.Item
                name="body"
                label="Request Body"
                tooltip="Use EJS syntax for templates: <%= call.fieldName %>"
            >
                <MonacoEditor
                    height="200"
                    language="json"
                    theme="vs-light"
                    options={editorOptions}
                    defaultValue={`{
  "callId": "<%= call.id %>",
  "score": <%= call.qualScore %>
}`}
                />

            </Form.Item>
</div>
);
};

export default WebhookConfig;
